import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div 
      className="flex-1 flex flex-col items-center justify-center p-12 text-center"
      style={{ color: 'var(--text-primary)', background: 'var(--surface-0)' }}
    >
      <div className="max-w-md space-y-4">
        <h2 className="text-xl font-bold">404 — Screen Not Found</h2>
        <p className="text-sm text-[var(--text-secondary)]">
          The requested workspace view or page does not exist.
        </p>
        <div className="pt-2">
          <Link 
            to="/app/dashboard" 
            className="inline-flex items-center justify-center px-4 py-2 rounded-lg text-sm font-semibold transition-all"
            style={{ background: 'var(--brand)', color: 'white' }}
          >
            Return to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
